import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { UIService } from '@core/services/ui.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressBar } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import { LanguageService } from './core/services/language.service';

@Component({
  selector: 'app-root',
  imports: [RouterModule, RouterOutlet, ToastModule, AsyncPipe, ProgressBar, ConfirmDialogModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (isLoading$ | async) {
      <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
    }

    <router-outlet></router-outlet>
    <!-- p-toast component that will get triggered from ui service -->
    <p-toast />
    <p-confirmdialog />
  `,
})
export class App implements OnInit {
  readonly languageService = inject(LanguageService);
  readonly UIService = inject(UIService);
  readonly isLoading$ = this.UIService.isLoading$;

  ngOnInit() {
    this.languageService.setupLanguages();
    this.UIService.initMode();
  }
}
